module.exports = __webpack_public_path__ + "filter-b2f392009e5e7c90bae37186fe9137e5.svg";